module.exports = __webpack_public_path__ + "img/circle_exclamation_mark.eef752e9.svg";